// @flow
import { createGlobalStyle } from "styled-components";
import { normalize } from "../normalize";
import { theme } from "../theme";
import { fonts } from "../fonts";

export const GlobalStyles = createGlobalStyle`
  ${normalize}
  ${fonts};

  * {
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    outline: none;
    font-family: ${theme.fonts.euclid};
  }

  body {
    color: ${theme.palette.hague};
  }

  a {
    color: inherit;
  }
`;
